import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { Flash } from '@/core/Flash';
import TicketCreateForm from '@/modules/ticket/components/TicketCreateForm.vue';
import { TicketCreate } from '@/modules/ticket/Ticket';


export default /*@__PURE__*/_defineComponent({
  __name: 'TicketCreate',
  setup(__props) {

const router = useRouter();
const { $gettext } = useGettext();

const ticket = ref<Partial<TicketCreate>>({
	reporter_name: '',
	ticket_category: undefined,
});

const saved = (ticket) => {
	Flash.success($gettext('Ärende sparat'));
	router.push({
		name: 'ticket.view',
		params: { id: ticket.id },
	});
};

const cancel = () => {
	router.push({ name: 'ticket.index' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TicketCreateForm, {
    ticket: ticket.value,
    onSaved: saved,
    onCancel: cancel
  }, null, 8, ["ticket"]))
}
}

})